import React from "react";
import { DsBadge } from "../../../design-system";

/** Employees whose salary structure was not saved, with the HR-facing reason. */
export default function StructureApplyAlerts({ alerts = [], title = "Structure alerts" }) {
  if (!alerts.length) return null;
  return (
    <section className="space-y-3">
      <div className="flex items-center justify-between gap-3">
        <h3 className="ds-h4 text-[hsl(var(--ds-fg))]">{title}</h3>
        <DsBadge tone="warning">
          {alerts.length} employee{alerts.length === 1 ? "" : "s"} without structure
        </DsBadge>
      </div>
      <p className="ds-caption text-[hsl(var(--ds-muted-fg))]">
        These employees still need a first salary-structure map. Payroll Process will block them until
        it is fixed. Use Run Payroll → New Joinees → Apply salary structures, or Payroll Dashboard →
        Apply Auto Structures / Manual Component Import.
      </p>
      <div className="overflow-hidden rounded-xl border border-[hsl(var(--ds-border))]">
        <div className="max-h-64 overflow-auto">
          <table className="ds-table w-full text-sm">
            <thead className="sticky top-0 bg-[hsl(var(--ds-muted))]">
              <tr>
                <th className="px-3 py-2 text-left">Emp Code</th>
                <th className="px-3 py-2 text-left">Name</th>
                <th className="px-3 py-2 text-left">Reason</th>
              </tr>
            </thead>
            <tbody>
              {alerts.map((a, i) => (
                <tr key={a.employee?.id ?? i} className="border-t border-[hsl(var(--ds-border))]">
                  <td className="px-3 py-2 whitespace-nowrap">
                    {a.employee?.empCode || a.employee?.employeeCode || "—"}
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap">
                    {[a.employee?.name || a.employee?.firstName || a.employee?.user?.name, a.employee?.lastName]
                      .filter(Boolean)
                      .join(" ") || "—"}
                  </td>
                  <td
                    className={`px-3 py-2 ${
                      a.pendingManual
                        ? "text-[hsl(var(--ds-warning-fg))]"
                        : "text-[hsl(var(--ds-danger))]"
                    }`}
                  >
                    {a.message}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
